export default {
	sec_10: {
		title: {
			one: '국제 규격 ',
			two: '지갑 사용',
		},
		desc: {
			one: '보안에 보안을 한 자체 지갑',
			two: '외부 지갑 업체가 아닌 자체 기술력으로 개발한 지갑을 사용합니다.',
		},
		btn: {
			one: '자산보내기',
			two: '앱 다운로드',
		},
	},
	sec_12: {
		title: {
			one: '국제 규격에 맞춘 ',
			two: 'LEVEL 2 이상의',
			three: '보안',
		},
		desc: {
			one: '한 번 더 보안을 신경써서',
			two: '해킹을 완벽하게 차단합니다.',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '개인키가 발생하지 않습니다.',
			},
			desc: {
				one: '관리자 및 DB 해킹이 들어와도',
				two: '개인키가 없어서 해킹이 어렵습니다.',
			},
		},
		two: {
			title: {
				one: '지갑이란 고객님의 금고와 같습니다.',
			},
			desc: {
				one: '저희 JP WORLD PAY는 자체 지갑을 제작 후',
				two: '보안에 보안을 거듭한 지갑이기에 해킹 대응에 최적화 되어 보안에 자신감을 가지고 있습니다.',
			},
		},
	},
};
